<template>
  <div>
    <b-card
      v-if="donation !== null && isUserAllowWrite"
      id="donationsEditCard"
      no-body
    >
      <b-card-header>
        <div class="d-flex align-items-center card-title-responsive-60">
          <feather-icon
            size="24"
            class="mr-1 d-none d-sm-block"
            :icon="(donation.did ? 'EditIcon' : 'FileTextIcon')"
          />
          <b-card-title class="ml-25">
            {{ $t('donations.' + (donation.did ? 'edit' : 'add-new') + (isGiverMode ? '-giver' : (donation.isRelated ? '-related' + (pid ? '-contributor' : '') : ''))) }}
          </b-card-title>
        </div>
        <b-button-group>
          <b-button
            class="btn-icon"
            variant="outline-primary"
            @click="close()"
          >
            <feather-icon
              class="text-nowrap d-block d-sm-none"
              icon="XIcon"
            />
            <span class="text-nowrap d-none d-sm-block">{{ $t('common.close') }}</span>
          </b-button>

          <b-button
            class="btn-icon"
            variant="outline-primary"
            :disabled="!somethingChanged || !isValidate"
            @click="submit()"
          >
            <feather-icon
              class="text-nowrap d-block d-sm-none"
              icon="SaveIcon"
            />
            <span class="text-nowrap d-none d-sm-block">{{ $t('common.save') }}</span>
          </b-button>
        </b-button-group>
      </b-card-header>

      <b-card-body>
        <donations-add
          ref="donationsAdd"
          v-model="donation"
          :refaid="refaid"
          :contributor="contributor"
          :project="project"
          :lookup-options="lookupOptions"
          :is-giver-mode="isGiverMode"
          :allow-select-projects="pid === null"
          :allow-select-contributors="cid === null"
        />
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-header>
        <div class="d-flex align-items-center card-title-responsive-40">
          <feather-icon
            size="24"
            class="mr-1 d-none d-sm-block"
            :icon="(isGiverMode ? 'LoaderIcon' : 'DollarSignIcon')"
          />
          <b-card-title class="ml-25">
            {{ $t('navigation.list-'+ (isGiverMode ? 'givers' : 'donations')) }}
          </b-card-title>
        </div>

        <b-button-group class="ml-1">
          <b-button
            v-if="isUserAllowWrite && !isFullGiver && !(isGiverMode && isUserLimitedProjects)"
            class="btn-icon"
            variant="outline-primary"
            @click="addNew()"
          >
            <feather-icon
              class="text-nowrap d-block d-sm-none"
              icon="FileIcon"
            />
            <span class="text-nowrap d-none d-sm-block">{{ $t('donations.add-new' + (isGiverMode ? '-giver' : '')) }}</span>
          </b-button>
          <b-button
            v-if="isUserAllowWrite && (cid || pid) && !isGiverMode && isChildren"
            class="btn-icon"
            variant="outline-primary"
            @click="addNew('related')"
          >
            <feather-icon
              class="text-nowrap d-block d-sm-none"
              icon="ShuffleIcon"
            />
            <span class="text-nowrap d-none d-sm-block">{{ $t('donations.related-new' + (pid ? '-contributor': '')) }}</span>
          </b-button>
          <b-button
            v-if="!pid || (pid && isChildren)"
            class="btn-icon"
            variant="outline-primary"
            @click="expoort()"
          >
            <feather-icon
              class="text-nowrap d-block d-sm-none"
              icon="ExternalLinkIcon"
            />
            <span class="text-nowrap d-none d-sm-block">{{ $t('common.export') }}</span>
          </b-button>
          <b-button
            v-if="(!cid && !pid) || isFiltering"
            id="btn-clean"
            variant="outline-primary"
            class="btn-icon"
            @click="clearFilters()"
          >
            <feather-icon icon="Trash2Icon" />
            <b-tooltip
              triggers="hover"
              target="btn-clean"
              :title=" $t('common.clean-filter')"
              :delay="{ show: 100, hide: 50 }"
            />
          </b-button>
          <b-button
            v-if="!cid && !pid"
            id="btn-refresh"
            variant="outline-primary"
            class="btn-icon"
            @click="refreshTable()"
          >
            <feather-icon icon="RefreshCcwIcon" />
            <b-tooltip
              triggers="hover"
              target="btn-refresh"
              :title=" $t('common.refresh')"
              :delay="{ show: 100, hide: 50 }"
            />
          </b-button>
          <b-button
            v-if="!isGiverMode && (pid ||cid)"
            class="btn-icon"
            variant="outline-primary"
            @click="filterings()"
          >
            <feather-icon
              :icon="isFiltering ? 'ArrowUpIcon' : 'FilterIcon'"
            />
          </b-button>
        </b-button-group>
      </b-card-header>

      <b-card-body>
        <donations-list-table
          ref="donationsListTable"
          :cid="cid"
          :pid="pid"
          :is-linked="isLinked"
          :refaid="refaid"
          :lookup-options="lookupOptions"
          :is-giver-mode="isGiverMode"
          :is-filtering="isFiltering"
          :linked-area="linkedArea"
          @onDonationDuplicateClick="duplicate"
          @onDonationEditClick="edit"
          @onDonationDeleteClick="deletee"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BButton, BButtonGroup, BTooltip,
} from 'bootstrap-vue'
import axios from '@axios'
import { ref } from '@vue/composition-api'
import authService from '@/vue.auth.service'
import lookupsService from '@/vue.lookups.service'
import DonationsListTable from '@/views/donations/DonationsListTable.vue'
import DonationsAdd from '@/views/donations/DonationsAdd.vue'
import {
  swalSaveOptions, toastSuccessOptions, swalCloseOptions, swalDeleteOptions, scrollTo, throwError,
} from '../layouts/layouts.utils'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BButton,
    BButtonGroup,
    BTooltip,
    DonationsListTable,
    DonationsAdd,
  },
  props: {
    cid: {
      required: false,
      default: null,
    },
    pid: {
      required: false,
      default: null,
    },
    isChildren: {
      type: Boolean,
      default: null,
    },
    isLinked: {
      required: false,
      default: null,
    },
    linkedArea: {
      required: false,
      default: null,
    },
    isGiverMode: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isFiltering: false,
      isUserAllowWrite: authService.isUserInRole('write'),
      isUserLimitedProjects: this.pid && authService.isUserInRole('limit-projects'),
    }
  },
  computed: {
    selected() { return this.$refs.donationsListTable.selected },
    isFullGiver() { return (this.isGiverMode && !this.cid && !this.pid) },
  },
  async mounted() {
    await this.reload()
    // eslint-disable-next-line no-underscore-dangle
    if (!this._events.changedArea) {
      this.$root.$on('changedArea', () => {
        this.reload()
      })
    }
    this.$watch('isGiverMode', () => { this.reload() })
    this.$watch('donation', () => {
      if (this.donation) {
        this.somethingChanged = true
        if (this.isGiverMode) {
          this.isValidate = (this.donation.amount && this.donation.issueDate && this.donation.currency)
        } else if (this.donation.isRelated) {
          this.isValidate = (this.donation.pid && this.cid) || (this.donation.cid && this.pid)
        } else {
          this.isValidate = (this.donation.amount && this.donation.issueDate
       && this.donation.infos.payments && this.donation.infos.type && this.donation.cid && this.donation.currency)
        }
      }
    }, { deep: true })
  },
  beforeDestroy() {
    this.$root.$off('changedArea')
  },
  methods: {
    async reload() {
      this.currentArea = await authService.currentArea()
      if (this.currentArea !== null) {
        await this.reloadArea(this.currentArea)
      }
    },
    async reloadArea(area) {
      this.close()
      this.refaid = area.aid
      this.areaSettings = area.settings.defaults
      const { obsoletes } = area.settings

      const options = {
        paymentsTypeOptions: await lookupsService.getMaps('donations.payments', area.aid, obsoletes),
        donationsTypeOptions: await lookupsService.getMaps('donations.type', area.aid, obsoletes),
        categoryOptions: await lookupsService.getMaps('donations.category', area.aid, obsoletes),
        giversTypeOptions: await lookupsService.getMaps('donations.giversType', area.aid, obsoletes),
        statusOptions: await lookupsService.getMaps('contributors.status', area.aid, obsoletes),
        tagsContributorsOptions: await lookupsService.getMaps('contributors.tags', area.aid),
        tagsProjectsOptions: await lookupsService.getMaps('projects.tags', area.aid),
        missionsOptions: await lookupsService.getMaps('projects.missionName', area.aid, obsoletes),
        nationsOptions: await lookupsService.getMaps('nations', area.aid, obsoletes),
        isChildrenOptions: lookupsService.getisChildrenOptions(),
        tagsOptions: await lookupsService.getMaps('donations.tags', area.aid, obsoletes),
        tagsColors: area.settings.tags,
      }
      this.lookupOptions = options
      this.$emit('on-reloaded')
    },
    async addNew(mode) {
      this.contributor = null
      const dons = {
        issueDate: new Date(),
        cid: this.cid,
        pid: this.pid,
        infos: { },
      }
      if (mode === 'related') {
        dons.isRelated = true
      } else {
        dons.infos.payments = this.areaSettings.paymentsType
        if (this.isGiverMode) dons.infos.balanceCurrency = this.areaSettings.currency
        else {
          dons.currency = this.areaSettings.currency
          dons.infos.type = this.areaSettings.donationsType
          dons.infos.category = this.areaSettings.category
        }
      }
      this.donation = dons
      await this.loadLinked()
      this.somethingChanged = false

      if (mode === 'related') {
        if (this.cid) this.$refs.donationsAdd.searchProjects()
      }
    },
    scrollToNew() {
      scrollTo('donationsEditCard')
    },
    async duplicate(did) {
      await this.edit(did)
      this.donation.issueDate = null
      this.donation.infos.notes = null
      this.donation.did = null
    },
    async edit(did) {
      const table = (this.isGiverMode ? 'givers' : 'donations')
      const resd = await axios.get(`/api/record/${table}`, { params: { aid: this.refaid, rid: did } })
      const dons = resd.data
      if (!dons.amount) {
        dons.infos.payments = this.areaSettings.paymentsType
        dons.currency = this.areaSettings.currency
        dons.infos.type = this.areaSettings.donationsType
        dons.infos.category = this.areaSettings.category
      }
      this.donation = dons
      await this.loadLinked()
      this.somethingChanged = false
      if (!this.cid && !this.pid) this.scrollToNew()
    },
    async deletee(did) {
      this.$swal(swalDeleteOptions).then(async result => {
        if (result.value === true) {
          const table = (this.isGiverMode ? 'givers' : 'donations')
          const resd = await axios.get(`/api/record/${table}`, { params: { aid: this.refaid, rid: did } })
          resd.pleaseDelete = true
          try {
            await axios.post(`/api/record/${table}`,
              JSON.stringify(resd),
              { params: { aid: this.refaid, rid: did } })
            this.$toast(toastSuccessOptions, { position: 'top-center' })
          } catch (error) { throwError(error) }
          setTimeout(this.refresh, 500)
        }
      })
    },
    async loadLinked() {
      if (this.donation.cid) {
        const resc = await axios.get('/api/record/contributors', { params: { aid: this.refaid, rid: this.donation.cid } })
        this.contributor = resc.data
      }
      if (this.donation.pid) {
        const resc = await axios.get('/api/record/projects', { params: { aid: this.refaid, rid: this.donation.pid } })
        this.project = resc.data
      }
    },
    refresh() {
      this.$refs.donationsListTable.refetchData()
      this.somethingChanged = false
      this.close()
    },
    close() {
      if (this.donation && this.somethingChanged) {
        this.$swal(swalSaveOptions).then(result => {
          if (result.value === true) {
            this.submit()
          } else if (result.value === false) {
            this.donation = null
            this.contributor = null
            this.project = null
          }
        })
      } else {
        this.donation = null
        this.contributor = null
        this.project = null
      }
    },
    async submit() {
      try {
        const did = (this.donation.did ? this.donation.did : 0)
        if (this.donation.pid && this.donation.pid !== null && this.donation.infos.nation !== null) {
          this.donation.infos.nation = null
        }
        const table = (this.isGiverMode ? 'givers' : 'donations')
        const response = await axios.post(`/api/record/${table}`,
          JSON.stringify(this.donation),
          { params: { aid: this.refaid, rid: did } })

        lookupsService.refreshMaps(this.donation.infos.payments, 'donations.payments', this.refaid, this.lookupOptions.paymentsTypeOptions)
        lookupsService.refreshMaps(this.donation.infos.type, 'donations.type', this.refaid, this.lookupOptions.donationsTypeOptions)
        lookupsService.refreshMaps(this.donation.infos.category, 'donations.category', this.refaid, this.lookupOptions.categoryOptions)
        lookupsService.refreshMaps(this.donation.infos.giversType, 'donations.giversType', this.refaid, this.lookupOptions.giversTypeOptions)
        lookupsService.refreshMaps(this.donation.infos.nation, 'nations', this.refaid, this.lookupOptions.nationsOptions)
        lookupsService.refreshMaps(this.donation.tags, 'donations.tags', this.refaid)

        if (did === 0) {
          this.refresh()
        } else {
          this.donation.editor = response.data.editor
          this.donation.lastUpdate = response.data.lastUpdate
          this.$toast(toastSuccessOptions, { position: 'top-center' })
          setTimeout(this.refresh, 500)
        }
        this.$emit('on-submit')
      } catch (error) { throwError(error) }
    },
    expoort() {
      this.$refs.donationsListTable.expoort()
    },
    refreshTable() {
      this.$refs.donationsListTable.refresh()
    },
    clearFilters() {
      this.$refs.donationsListTable.clearFilters()
    },
    filterings() {
      this.isFiltering = !this.isFiltering
    },
  },
  setup() {
    const refaid = ref(null)
    const somethingChanged = ref(false)
    const isValidate = ref(false)

    const areaSettings = ref(null)
    const donation = ref(null)
    const contributor = ref(null)
    const project = ref(null)
    const lookupOptions = ref({})

    return {
      refaid,
      somethingChanged,
      isValidate,
      areaSettings,
      lookupOptions,
      donation,
      contributor,
      project,
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (this.somethingChanged) {
      const result = await this.$swal(swalCloseOptions)
      if (!result.value) {
        next(false)
        return
      }
    }
    this.donation = null
    next()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
